var render, staticRenderFns
import script from "./RealTime.vue?vue&type=script&lang=js"
export * from "./RealTime.vue?vue&type=script&lang=js"
import style0 from "./RealTime.vue?vue&type=style&index=0&id=a85474aa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a85474aa",
  null
  
)

export default component.exports